
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const Mailbox20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M3.5 2a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H7v3H5.5A3.5 3.5 0 0 0 2 11.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5.5A3.5 3.5 0 0 0 14.5 8H8V2.5a.5.5 0 0 0-.5-.5h-4ZM7 9v2.5a.5.5 0 0 0 1 0V9h4.05A3.49 3.49 0 0 0 11 11.5V17H3v-5.5A2.5 2.5 0 0 1 5.5 9H7Zm10 2.5V17h-5v-5.5a2.5 2.5 0 0 1 5 0Zm-3-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
            fill="currentColor"
        />
    </svg>
}